<template>
  <div class="footer">
    <p> {{res.footer_info_copyright }}  </p>
    <p> <a href="//beian.miit.gov.cn/" target="_blank">{{ res.footer_info_icp }}</a> </p>

     <p> {{res.report_mobile}}</p>
      <p> {{res.report_email}}</p>
  </div>
</template>

<script>
export default {
  data:function () {
    return {
      res: {
        footer_info_copyright:"",
        footer_info_icp:"",
        report_mobile:"",
        report_email:"",
      }
    }
  },
  created(){
    console.log("footer created")
    this.fetch();
  },
  methods:{
    async fetch(){
      const data = await this.$fly.get("/common/footer");
      this.$set(this.res,'footer_info_copyright', data.footer_info_copyright);
      this.$set(this.res,'footer_info_icp', data.footer_info_icp);
      this.$set(this.res,'report_mobile', data.report_mobile);
      this.$set(this.res,'report_email', data.report_email);
      
      // console.log("footer:",this.res);
    }
  }
}
</script>

<style lang='scss'>
.footer{
  background-color: #575757;
  padding: 22px 0;
  font-size: 12px;
  color: #999;  

  p{
    text-align: center;
  }
  a{
    color: #999;
  }
}

</style>
